const seo = {
  data () {
    return {
      seoDefaultDescription: 'Painel administrativo',
      seoDefaultTitle: 'Pixel Roads',
      seoDefaultTitleAppend: 'Pixel Roads Administrativo',
      seoDefaultImage: `${process.env.VUE_APP_BASE_URL}/images/facebook-og-v2.png`
    }
  }
}

export default seo
